export default __webpack_public_path__ + "OpenSans-Bold-dbb97fd982ce1b96b6de90a9f1c2ecaa.ttf";